/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Theme_SystemInputs */

const en_us2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const pt_br2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const es_419_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const pt_pt2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

const fr_fr2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Système`)
};

const de_de2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System`)
};

const it_it2_profile_theme_system = /** @type {(inputs: Profile_Theme_SystemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistema`)
};

/**
* | output |
* | --- |
* | "System" |
*
* @param {Profile_Theme_SystemInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_theme_system = /** @type {((inputs?: Profile_Theme_SystemInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Theme_SystemInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_theme_system(inputs)
	if (locale === "es-419") return es_419_profile_theme_system(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_theme_system(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_theme_system(inputs)
	if (locale === "de-DE") return de_de2_profile_theme_system(inputs)
	if (locale === "it-IT") return it_it2_profile_theme_system(inputs)
	return en_us2_profile_theme_system(inputs)
});
export { profile_theme_system as "profile.theme_system" }